import Text from 'components/Text/Text';
import React from 'react';
import { Link } from 'react-router-dom';
import Button from 'components/Button/Button';
import { useRoleAccess } from 'hooks/useRoleAccess';
import { UserRoles } from 'types';
import breadcrumbs from 'images/breadcrumbs.svg';
import style from './DevelopersBtn.module.scss';

const DevelopersBtn: React.FC = () => {
	const hasAccess = useRoleAccess([UserRoles.SUPER_USER, UserRoles.TECHNICAL]);

	return (
		<Link
			className={style.container}
			to={`/entertainment/games${hasAccess ? '/developers' : ''}`}
			data-test="DevelopersBtn">
			<Button
				className={style.button}
				theme="primaryBlue"
				icon={
					<svg className={style.icon}>
						<use xlinkHref={`${breadcrumbs}#adminSettings`} />
					</svg>
				}
				disabled={!hasAccess}>
				<Text translationNameSpace="listing" translationKey="developersButton" asFragment={true} />
			</Button>
		</Link>
	);
};

export default DevelopersBtn;
